export function useDirectusImage() {
  const config = useRuntimeConfig()
  const baseUrl = config.public.directusUrl

  function imageUrl(fileId: string | null, options?: { width?: number, height?: number, quality?: number, format?: string }) {
    if (!fileId) return null
    const params = new URLSearchParams()
    if (options?.width) params.set('width', String(options.width))
    if (options?.height) params.set('height', String(options.height))
    if (options?.quality) params.set('quality', String(options.quality))
    if (options?.format) params.set('format', options.format)
    const qs = params.toString()
    return `${baseUrl}/assets/${fileId}${qs ? `?${qs}` : ''}`
  }

  return { imageUrl }
}
